import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DHLogo from "../assets/PeranaSportsSquare512.png";
import { fetchUser } from "../utils/dbutils";
import { initPageTranslations } from "../utils/utils";

export default function SignIn() {
  const navigate = useNavigate();
  const phrases = [
    "Sign in to your account",
    "Email address",
    "Password",
    "Remember me",
    "Forgot password?",
    "Sign in",
    "Not a member?",
    "Sign up",
    "You are no longer an active guide at Companion",
    "You are no longer an active client at Companion",
    "Error signing in",
  ];
  const [translations, setTranslations] = useState(null);
  const { register, handleSubmit } = useForm();
  const onSubmit = async (data) => {
    const { email, password } = data;
    console.log(data);
    try {
      const auth = getAuth();

      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      if (userCredential.user) {
        var user = await fetchUser(userCredential.user.uid);
        navigate("/frontpage");
      }
    } catch (error) {
      toast.error("Error signing in" + "\n" + error.message);
    }
  };

  const initTranslations = async () => {
    const tr = await initPageTranslations(phrases, "SignIn");
    setTranslations(tr);
  };

  useEffect(() => {
    if (!translations) {
      initTranslations();
    }
  }, [translations]);

  if (!translations) return <></>;

  return (
    <>
      <div className="">
        <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
          <div className="w-full max-w-sm space-y-10">
            <div className="mt-10">
              <img
                className="mx-auto h-28 w-auto"
                src={DHLogo}
                alt="Dong Hanh"
              />
              <h2 className="mt-4 text-center text-2xl font-bold leading-9 tracking-tight text-base-content">
                {translations["Sign in to your account"]}
              </h2>
            </div>
            <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              <div className="relative -space-y-px rounded-md shadow-sm">
                <div className="pointer-events-none absolute inset-0 z-10 rounded-md ring-1 ring-inset ring-base-300" />
                <div>
                  <label htmlFor="email-address" className="sr-only">
                    {translations["Email address"]}
                  </label>
                  <input
                    {...register("email")}
                    id="email-address"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="relative block w-full rounded-t-md border-0 p-1.5 text-base-content ring-1 ring-inset ring-base-300 placeholder:text-base-content/50 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    placeholder={translations["Email address"]}
                  />
                </div>
                <div>
                  <label htmlFor="password" className="sr-only">
                    {translations["Password"]}
                  </label>
                  <input
                    {...register("password")}
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    className="relative block w-full rounded-b-md border-0 p-1.5 text-base-content ring-1 ring-inset ring-base-300 placeholder:text-base-content/50 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    placeholder={translations["Password"]}
                  />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 rounded border-base-300 text-primary focus:ring-primary"
                  />
                  <label
                    htmlFor="remember-me"
                    className="ml-3 block text-sm leading-6 text-base-content"
                  >
                    {translations["Remember me"]}
                  </label>
                </div>

                <div className="text-sm leading-6">
                  <a
                    href="#"
                    className="font-semibold text-primary hover:text-primary-focus"
                  >
                    {translations["Forgot password?"]}
                  </a>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-primary px-3 py-1.5 text-sm font-semibold leading-6 text-primary-content hover:bg-primary-focus focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                >
                  {translations["Sign in"]}
                </button>
              </div>
            </form>

            <p className="text-center text-sm leading-6 text-base-content/60">
              {translations["Not a member?"]}
              <a
                href="/sign-up"
                className="font-semibold text-primary hover:text-primary-focus"
              >
                {" "}
                {translations["Sign up"]}
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
